/* MIKADO theme.js v3.1 — vanilla, gallery variant-aware */
(function(){'use strict';
const w=window,d=document;w.mikado=w.mikado||{};
const $=(s,c)=>(c||d).querySelector(s);
const $$=(s,c)=>Array.from((c||d).querySelectorAll(s));
w.mikado.formatMoney=(c)=>(c/100).toFixed(2).replace('.',',')+' €';

function initReveal(){if(!('IntersectionObserver' in w)){$$('.reveal').forEach(el=>el.classList.add('is-visible'));return;}const o=new IntersectionObserver((es)=>{es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-visible');o.unobserve(e.target);}});},{threshold:0.12,rootMargin:'0px 0px -10% 0px'});$$('.reveal').forEach(el=>o.observe(el));}
function initHeaderScroll(){const h=$('.header');if(!h)return;const fn=()=>h.classList.toggle('is-scrolled',w.scrollY>40);w.addEventListener('scroll',fn,{passive:true});fn();}

const overlay=$('#mikado-overlay');let activeDrawer=null,lastFocused=null;
const focusableSel='a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
function openDrawer(s){const dr=typeof s==='string'?$(s):s;if(!dr)return;lastFocused=d.activeElement;dr.setAttribute('aria-hidden','false');if(overlay)overlay.setAttribute('aria-hidden','false');d.body.style.overflow='hidden';activeDrawer=dr;setTimeout(()=>{const f=$(focusableSel,dr);if(f)f.focus();},100);}
function closeDrawer(s){const dr=s?(typeof s==='string'?$(s):s):activeDrawer;if(!dr)return;dr.setAttribute('aria-hidden','true');if(overlay)overlay.setAttribute('aria-hidden','true');d.body.style.overflow='';activeDrawer=null;if(lastFocused)lastFocused.focus();}
w.mikado.openDrawer=openDrawer;w.mikado.closeDrawer=closeDrawer;
function trapFocus(c,e){const fs=$$(focusableSel,c).filter(el=>el.offsetParent!==null);if(!fs.length||e.key!=='Tab')return;const first=fs[0],last=fs[fs.length-1];if(e.shiftKey&&d.activeElement===first){last.focus();e.preventDefault();}else if(!e.shiftKey&&d.activeElement===last){first.focus();e.preventDefault();}}
d.addEventListener('click',e=>{if(e.target.closest('[data-mikado-cart-open]')){e.preventDefault();openDrawer('#mikado-cart-drawer');}if(e.target.closest('[data-mikado-cart-close]')){e.preventDefault();closeDrawer('#mikado-cart-drawer');}if(e.target.closest('[data-mikado-mobile-open]')){e.preventDefault();openDrawer('#mikado-mobile-menu');}if(e.target.closest('[data-mikado-mobile-close]')){e.preventDefault();closeDrawer('#mikado-mobile-menu');}});
if(overlay)overlay.addEventListener('click',()=>closeDrawer());
d.addEventListener('keydown',e=>{if(!activeDrawer)return;if(e.key==='Escape')closeDrawer();else if(e.key==='Tab')trapFocus(activeDrawer,e);});

const toastEl=$('#mikado-toast');let toastTimer=null;
function showToast(msg,opts){if(!toastEl){console.log('[toast]',msg);return;}opts=opts||{};toastEl.textContent=msg;toastEl.setAttribute('aria-hidden','false');clearTimeout(toastTimer);toastTimer=setTimeout(()=>toastEl.setAttribute('aria-hidden','true'),opts.duration||3000);}
w.mikado.toast=showToast;

d.addEventListener('click',e=>{const dec=e.target.closest('[data-qty-decrement]'),inc=e.target.closest('[data-qty-increment]');if(!dec&&!inc)return;e.preventDefault();const wr=(dec||inc).closest('.quantity');if(!wr)return;const inp=$('[data-qty-input], input[type="number"]',wr);if(!inp)return;let v=parseInt(inp.value,10)||1;v=dec?Math.max(1,v-1):v+1;inp.value=v;inp.dispatchEvent(new Event('change',{bubbles:true}));});

const WK='mikado:wishlist';
function wG(){try{return JSON.parse(localStorage.getItem(WK)||'[]');}catch(_){return[];}}
function wS(a){try{localStorage.setItem(WK,JSON.stringify(a));}catch(_){}}
function wH(h){return wG().includes(h);}
function wT(h){const a=wG(),i=a.indexOf(h);if(i>=0){a.splice(i,1);wS(a);return false;}a.push(h);wS(a);return true;}
function wSy(){$$('[data-mikado-wishlist]').forEach(b=>{const h=b.dataset.productHandle;b.setAttribute('aria-pressed',wH(h)?'true':'false');});}
w.mikado.wishlist={get:wG,has:wH,toggle:wT};
d.addEventListener('click',e=>{const b=e.target.closest('[data-mikado-wishlist]');if(!b)return;e.preventDefault();e.stopPropagation();const h=b.dataset.productHandle;if(!h)return;const on=wT(h);b.setAttribute('aria-pressed',on?'true':'false');showToast(on?'Ajouté à votre sélection':'Retiré de votre sélection');});

function initMegaNav(){$$('[data-mega-nav]').forEach(nav=>{const tr=$('[data-mega-trigger]',nav),pa=$('[data-mega-panel]',nav);if(!tr||!pa)return;let timer;const open=()=>{clearTimeout(timer);$$('[data-mega-nav].is-open').forEach(n=>{if(n!==nav){n.classList.remove('is-open');$('[data-mega-trigger]',n).setAttribute('aria-expanded','false');}});nav.classList.add('is-open');tr.setAttribute('aria-expanded','true');};const close=(imm)=>{clearTimeout(timer);timer=setTimeout(()=>{nav.classList.remove('is-open');tr.setAttribute('aria-expanded','false');},imm?0:150);};nav.addEventListener('mouseenter',open);nav.addEventListener('mouseleave',()=>close(false));pa.addEventListener('mouseenter',()=>clearTimeout(timer));tr.addEventListener('click',e=>{e.preventDefault();if(nav.classList.contains('is-open'))close(true);else open();});});d.addEventListener('keydown',e=>{if(e.key!=='Escape')return;$$('[data-mega-nav].is-open').forEach(n=>{n.classList.remove('is-open');$('[data-mega-trigger]',n).setAttribute('aria-expanded','false');});});d.addEventListener('click',e=>{if(e.target.closest('[data-mega-nav]'))return;$$('[data-mega-nav].is-open').forEach(n=>{n.classList.remove('is-open');$('[data-mega-trigger]',n).setAttribute('aria-expanded','false');});});}

/* Variant selector — vanilla, robust */
function initVariantSelectors(){
  $$('[data-variant-selectors]').forEach(container=>{
    const dataScript=container.parentElement.querySelector('[data-product-variants-data]');
    if(!dataScript)return;
    let data;
    try{data=JSON.parse(dataScript.textContent);}catch(e){console.warn('[mikado] variant data parse error',e);return;}
    const variants=data.variants;
    let current=variants.find(v=>v.id==data.currentVariantId)||variants[0];
    let selected=current.options.slice();

    function findVariant(){return variants.find(v=>v.options.every((opt,i)=>opt===selected[i]));}

    function updateUI(){
      const v=findVariant();
      if(!v)return;
      current=v;
      $$('[data-variant-id-input], [data-variant-id-input-fallback]').forEach(inp=>{inp.value=v.id;});
      $$('.swatch',container).forEach(btn=>{
        const idx=parseInt(btn.dataset.optionIndex,10);
        btn.setAttribute('aria-checked',btn.dataset.optionValue===selected[idx]?'true':'false');
      });
      selected.forEach((val,i)=>{const lbl=container.querySelector('[data-selected-value-'+i+']');if(lbl)lbl.textContent=val;});
      const priceEl=$('.product-page__price');
      if(priceEl){
        const meta=priceEl.querySelector('[itemprop="price"]');
        if(meta)meta.setAttribute('content',(v.price/100).toFixed(2));
        const tn=Array.from(priceEl.childNodes).find(n=>n.nodeType===3&&n.textContent.trim().length);
        if(tn)tn.textContent=' '+w.mikado.formatMoney(v.price);
      }
      const av=$('[data-availability]');
      if(av){
        const inStock=v.inventoryManaged?v.inventoryQuantity>0:v.available;
        if(inStock){av.innerHTML='<p class="text-meta accent">En stock — livré sous 2 à 3 jours</p>';}
        else if(v.available){av.innerHTML='<p class="text-meta muted">Sur commande — 4 à 5 semaines</p>';}
        else{av.innerHTML='<p class="text-meta muted">Indisponible pour le moment</p>';}
      }
      const atc=$('[data-add-to-cart]');
      if(atc){
        atc.disabled=!v.available;
        const t=atc.querySelector('[data-add-to-cart-text]');
        if(t)t.textContent=v.available?'Ajouter au panier':'Indisponible';
      }
      const url=new URL(window.location.href);
      url.searchParams.set('variant',v.id);
      history.replaceState({},'',url.toString());
      // Notifier la gallery
      window.dispatchEvent(new CustomEvent('mikado:variant-change',{detail:{variantId:v.id,featuredMediaId:v.featuredMediaId}}));
    }

    $$('.swatch',container).forEach(btn=>{
      btn.addEventListener('click',e=>{
        e.preventDefault();
        const idx=parseInt(btn.dataset.optionIndex,10);
        const val=btn.dataset.optionValue;
        if(isNaN(idx)||!val)return;
        selected[idx]=val;
        updateUI();
      });
    });
  });
}

/* Product gallery — variant-aware: show/hide slides based on data-variant-id */
function initGalleries(){
  $$('[data-product-gallery]').forEach(gallery=>{
    function getVisibleSlides(){return $$('.product-gallery__slide',gallery).filter(s=>!s.hidden);}
    function getVisibleThumbs(){return $$('.product-gallery__thumb',gallery).filter(s=>!s.hidden);}
    function setActive(mediaId){
      $$('.product-gallery__slide',gallery).forEach(s=>{
        s.classList.toggle('is-active',s.dataset.mediaId===String(mediaId));
      });
      $$('.product-gallery__thumb',gallery).forEach(t=>{
        t.classList.toggle('is-active',t.dataset.thumbMediaId===String(mediaId));
      });
    }
    function activateFirstVisible(){
      const first=getVisibleSlides()[0];
      if(first)setActive(first.dataset.mediaId);
    }
    function updateForVariant(variantId){
      const vid=String(variantId);
      gallery.dataset.currentVariant=vid;
      // hide/show slides
      $$('.product-gallery__slide',gallery).forEach(s=>{
        const owner=s.dataset.variantId||'';
        s.hidden=(owner!==''&&owner!==vid);
      });
      $$('.product-gallery__thumb',gallery).forEach(t=>{
        const owner=t.dataset.variantId||'';
        t.hidden=(owner!==''&&owner!==vid);
      });
      // Activate variant's featured media (if visible) or first visible
      const variantSlide=gallery.querySelector('.product-gallery__slide[data-variant-id="'+vid+'"]:not([hidden])');
      if(variantSlide){setActive(variantSlide.dataset.mediaId);}
      else{activateFirstVisible();}
    }
    // Thumb clicks
    $$('.product-gallery__thumb',gallery).forEach(t=>{
      t.addEventListener('click',()=>setActive(t.dataset.thumbMediaId));
    });
    // Variant change listener
    window.addEventListener('mikado:variant-change',e=>{
      if(!e.detail||!e.detail.variantId)return;
      updateForVariant(e.detail.variantId);
    });
  });
}

function init(){
  initReveal();
  initHeaderScroll();
  initMegaNav();
  initVariantSelectors();
  initGalleries();
  wSy();
}
if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',init);else init();
})();
